import React from 'react';
import { Carousel } from 'react-bootstrap';
import { includes, some } from 'lodash';
import ReactPlayer from 'react-player';
import CommonAction from '../../../Pages/Library/DPP/Library/TemplateComponent/CommonAction';
import noImage from '../../../assets/images/no-image.png';

export function DigitalAsset(props) {
  const { dataIndex, editingInput, deleteItem, assets, fromProduct, dppAddEditAccess, isProductArchived, index, publishHtml = false } = props;

  const setVideo = (video) => {
    const words = ['/dam/', '/dam_folder/'];
    let videoPath = '';
    if (video?.includes('data:video/')) {
      videoPath = video;
    } else if (video?.includes('https')) {
      videoPath = video;
    } else if (some(words, (word) => includes(video, word))) {
      videoPath = `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${video}`;
    } else if (video?.includes('https://') || video?.includes('http://')) {
      videoPath = video;
    } else {
      videoPath = noImage;
    }
    return videoPath;
  };

  const toEmbedUrl = (rawUrl) => {
    const input = (rawUrl || '').trim();
    if (!input) return '';
    try {
      const parsed = new URL(input);
      const hostname = parsed.hostname.toLowerCase();
      // YouTube handling
      if (hostname.includes('youtube.com') || hostname.includes('youtu.be')) {
        let videoId = '';
        let startParam = '';
        if (hostname.includes('youtu.be')) {
          videoId = parsed.pathname.replace(/^\//, '');
          // youtu.be/<id>?t=90 or ?si=...
          const t = parsed.searchParams.get('t');
          if (t) {
            const seconds = /^(\d+)(s)?$/i.test(t) ? parseInt(t, 10) : 0;
            if (seconds > 0) startParam = `&start=${seconds}`;
          }
        } else if (parsed.pathname.startsWith('/watch')) {
          videoId = parsed.searchParams.get('v') || '';
          const t = parsed.searchParams.get('t');
          if (t) {
            const seconds = /^(\d+)(s)?$/i.test(t) ? parseInt(t, 10) : 0;
            if (seconds > 0) startParam = `&start=${seconds}`;
          }
        } else if (parsed.pathname.startsWith('/embed/')) {
          videoId = parsed.pathname.split('/')[2];
        }
        if (videoId) {
          return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1${startParam}`;
        }
      }
      // Vimeo handling (supports hashed links like vimeo.com/<id>/<hash>)
      if (hostname.includes('vimeo.com')) {
        let videoId = '';
        let hashParam = '';
        if (hostname === 'vimeo.com' || hostname === 'www.vimeo.com') {
          const parts = parsed.pathname.split('/').filter(Boolean);
          // parts: [id] or [id, hash]
          if (parts.length >= 1) {
            videoId = parts[0];
          }
          if (parts.length >= 2) {
            hashParam = `?h=${parts[1]}`;
          }
        } else if (hostname === 'player.vimeo.com') {
          const parts = parsed.pathname.split('/').filter(Boolean);
          // parts: [video, id]
          const idIndex = parts.indexOf('video');
          if (idIndex >= 0 && parts[idIndex + 1]) {
            videoId = parts[idIndex + 1];
          }
          const h = parsed.searchParams.get('h');
          if (h) hashParam = `?h=${h}`;
        }
        if (videoId) {
          return `https://player.vimeo.com/video/${videoId}${hashParam}`;
        }
      }
      return input;
    } catch (_) {
      return input;
    }
  };

  const isYouTubeOrVimeo = (rawUrl) => {
    const input = (rawUrl || '').trim();
    if (!input) return false;
    try {
      const parsed = new URL(input);
      const h = parsed.hostname.toLowerCase();
      return h.includes('youtube.com') || h.includes('youtu.be') || h.includes('vimeo.com');
    } catch (_) {
      return false;
    }
  };

  const renderContent = (asset) => {
    let mediaContent;
    // Prefer video when present
    if (asset?.videoUrl || asset?.videoLink) {
      const rawUrl = asset?.videoUrl || asset?.videoLink;
      if (publishHtml && isYouTubeOrVimeo(rawUrl)) {
        const embedUrl = toEmbedUrl(rawUrl);
        mediaContent = (
          <div className="video-embed" data-video-embed-url={embedUrl}>
            <iframe
              title="video"
              width="100%"
              height="250"
              src={embedUrl}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        );
      } else if (publishHtml) {
        // Direct video file (e.g., mp4 on S3) for static HTML
        const fileUrl = setVideo(rawUrl);
        mediaContent = (
          <video width="100%" height="250" controls>
            <source src={fileUrl} />
            <track kind="captions" label="captions" />
            Your browser does not support the video tag.
          </video>
        );
      } else {
        mediaContent = <ReactPlayer light={asset?.videoThumbnail} className="react-player" url={setVideo(rawUrl)} width="100%" height={250} controls />;
      }
    } else if (asset?.croppedImage || asset?.imageUrl || asset?.imageLink) {
      mediaContent = (
        <img
          src={asset?.croppedImage || asset?.imageUrl || asset?.imageLink || noImage}
          alt=""
          className="d-block w-100"
          style={{ maxHeight: '350px', objectFit: 'contain' }}
        />
      );
    } else {
      mediaContent = <img src={noImage} alt="" className="d-block w-100" style={{ maxHeight: '350px', objectFit: 'contain' }} />;
    }
    return mediaContent;
  };
  return (
    <div className={fromProduct ? 'digital-asset-control product-carousel' : 'digital-asset-control'}>
      <Carousel interval={2000} id={`demo_${index}`} data-ride="carousel">
        {fromProduct && assets && assets.length > 0 ? (
          assets.map((asset) => (
            <Carousel.Item key={asset?._id} data-target={`#demo_${index}`}>
              {renderContent(asset)}
            </Carousel.Item>
          ))
        ) : (
          <Carousel.Item data-target={`#demo_${index}`}>
            <img src={noImage} className="img-fluid" style={{ maxHeight: '350px', objectFit: 'contain' }} alt="" />
          </Carousel.Item>
        )}
      </Carousel>

      <CommonAction
        editingInput={editingInput}
        deleteItem={deleteItem}
        dataIndex={dataIndex}
        dppAddEditAccess={dppAddEditAccess}
        isProductArchived={isProductArchived}
      />
    </div>
  );
}

export default DigitalAsset;
